import { ISelectOptions } from '../models/common.model'

export const CNoneOption: ISelectOptions = {
    name: 'None',
    value: '',
}

export const CActions = {
    save: {
        name: 'Save',
        value: 'save',
    },
    edit: {
        name: 'Edit',
        value: 'edit',
        className: 'outline-red',
    },
}

export const CDisabledActions = {
    save: {
        ...CActions.save,
        disabled: true,
    },
    edit: {
        ...CActions.edit,
        disabled: true,
    },
}

export const CDisabledWithLoading = {
    save: {
        ...CDisabledActions.save,
        isLoading: true,
    },
    edit: {
        ...CDisabledActions.edit,
        isLoading: true,
    },
}

export const CAlphabet = 'abcdefghijklmnopqrstuvwxyz'
